import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import { DotLottie } from '@lottiefiles/dotlottie-web';

class Banner extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}
	initLottie() {
		const lottieWrapper = this.selector.querySelector( '.lottie-wrapper' ) as HTMLElement;
		const lottieUrl = lottieWrapper ? lottieWrapper?.dataset?.lottieUrl : '';
		if ( lottieUrl ) {
			new DotLottie( {
				autoplay: true,
				loop: false,
				canvas: lottieWrapper.querySelector( '#dotlottie-canvas' ),
				src: lottieUrl,
			} );
		}
	}
	init() {
		this.initLottie();
	}
}

export default Banner;
